import * as React from "react"
import About from "../components/main/About"
import Layout from "../components/layout"
import Seo from "../components/seo"

const AboutPage = () => (
  <Layout>
    <Seo title="About" />
    <About />
  </Layout>
)

export default AboutPage
